/**
 * Helper function to apply lots of mixins
 * usage:
 *
 *    class Foo extends mixin(BaseClass, MixA, MixB, MixC) { ... }
 *
 * is the same as:
 *
 *    class Foo extends MixC(MixB(MixA(BaseClass))) { ... }
 */
export default function mixin(klass, mix = undefined, ...rest) {
  if (!mix) return klass

  return mixin(mix(klass), ...rest)
}
